<template>
    <div class="home" v-loading.fullscreen.lock="fullscreenLoading">
        <theme class="theme"></theme>
        <div class="iframe-box" >
            <div v-bind:style="fade_top"></div>
                <iframe  src="http://pupai.nas.cpolar.cn/GeotextilesLayingVessel/WebContent/Web2/index.html"  frameborder="no" class="trend-container2" id="iframe" marginwidth="0" scrolling="no"></iframe>
                <!-- <iframe  name='MyFrame' src="http://192.168.0.109:8082/"  frameborder="no" class="trend-container2" id="iframe" marginwidth="0" scrolling="no"></iframe> -->
            <div class="fade_bottom"></div>
            </div>
            <div class="tag_unit" ref="tag_unit" >
                <div class="tag_head">
                    <div class="tagInner_box">
                        <h1>形象进度</h1>
                        <button class="formButton check_deteil" @click="outOfDetail">退出</button>
                    </div>
                </div>
                <div class="tag_body">
                    <div class="top">
                        <div class="event_title" >
                                    <el-select :disabled='true'   class="inputInner" :value="layer_detail.label">
                                        <el-option
                                        v-for="item in labelGroup"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                        <div class="colBox">
                                <el-row style="width:80%">
                                    <!-- <p style="margin-right:2%;color:var(--subject--text)">{{layer_detail.startpile}}</p> -->
                                    <el-col  v-for="(num,idx) in layer_detail.layerShowArr" :key="idx" :span="24">
                                        <div  :style="`width:${num*100}%;min-width:3px;`" :class="idx%2==0?'grid-content bg-purple':'grid-content bg-purple-light'"></div><p class="colP">{{layer_detail.layerNumArr[idx]}}</p>
                                    </el-col>
                                    <div id="bgcontent" class="grid-content bg-purple"></div>
                                    <p style="position: absolute;right:-12%;color:var(--subject--text)">{{layer_detail.endpile}}</p>
                                </el-row>
                           </div>
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="colBox">
                                <label style="width:30%;display:flex;justify-content:center" class="input_label" for="">计划进度：</label>
                                <el-row style="width:46%">
                                    <el-col  :span="24">
                                        <div  :style="`width:${layer_detail.Material_group_fact}%;min-width:3px;`" class='grid-content bg-purple'></div>
                                    </el-col>
                                    <div id="bgcontent" class="grid-content bg-purple"></div>
                                    <p style="position: absolute;right:-35%;color:var(--subject--text)">{{layer_detail.Material_group_fact}}%</p>
                                </el-row>
                            </div>
                            <div class="colBox">
                                <label style="width:30%;display:flex;justify-content:center" class="input_label" for="">实际进度：</label>
                                <el-row style="width:46%">
                                    <el-col  :span="24">
                                        <div  :style="`width:${getSchedule(new Date())}%;min-width:3px;`" class='grid-content bg-purple'></div>
                                    </el-col>
                                    <div id="bgcontent" class="grid-content bg-purple"></div>
                                    
                                    <p style="position: absolute;right:-35%;color:var(--subject--text)">{{getSchedule(new Date())}}%</p>
                                </el-row>
                            </div>
                        </div>
                        <div class="right">
                            <div class="table_area">
                                    <el-checkbox-group >
                                        <el-checkbox  v-for="event in eventOptions" :label="event.value"  :key="event.value">{{event.label}}</el-checkbox> 
                                    </el-checkbox-group>
                            </div>

                        </div>
                    </div>
                    
                </div>
            </div>
        
        <div class="layout" v-show="layout">
            <div ref='menu' class="menu">
            <button @click="getPop(0)" class="menu_btn btn_1"><div class="menu_icon mi_1"></div><p>工程管理</p></button>
            <button @click="getPop(1)" class="menu_btn btn_2"><div class="menu_icon mi_2"></div><p>质量管理</p></button>
            <button @click="getPop(2)" class="menu_btn btn_3"><div class="menu_icon mi_3"></div><p>材料管理</p></button>
            <button @click="getPop(3)" class="menu_btn btn_4"><div class="menu_icon mi_4"></div><p>设备管理</p></button>
            <button @click="getPop(4)" class="menu_btn btn_4"><div class="menu_icon mi_5"></div><p>轨迹回溯</p></button>
            <!-- <button class="menu_btn btn_4"><div class="menu_icon mi_4"></div><p>设备管理</p></button> -->
            </div>
            <div ref="tag" class="projectInfo tag">
                <div class="tag_head projectInfo_head">
                    <div class="tagInner_box">
                        <h1>形象进度</h1>
                        <button class="formButton check_deteil" @click="checkDeteil" v-if="Tag" >详情</button>
                        <button class="formButton check_deteil" @click="checkDeteil" v-else >关闭</button>
                    </div>
                </div>
                <!-- projectInfo_body -->
                <div class="tag_body projectInfo_body ">
                    <div class="project_events" >
                        <div class="project_event"  v-for="(item,key) in visualProgress" :key=key>
                            <div class="textBox">
                                <!-- <div class="event_title" >{{item.label}}</div> -->
                                <div class="event_title" >
                                    <el-select :disabled='true'  class="inputInner" :value="item.label">
                                        <el-option
                                        v-for="item in labelGroup"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="event_inner">
                                    <button @click="showWorkArea(key,item)" class="formButton workArea"><img class="cheackEyes" src="@/assets/icon/eyes.png" alt=""> 显示工区</button>
                                </div>
                            </div>
                           <div class="colBox">
                                <el-row style="width:80%">
                                    <p style="margin-right:2%;color:var(--subject--text)">{{item.startpile}}</p>
                                    <el-col  v-for="(num,idx) in item.layerShowArr" :key="idx" :span="24">
                                        <div  :style="`width:${num*100}%;min-width:3px;`" :class="idx%2==0?'grid-content bg-purple':'grid-content bg-purple-light'"></div><p class="colP">{{item.layerNumArr[idx]}}</p>
                                    </el-col>
                                    <div id="bgcontent" class="grid-content bg-purple"></div>
                                    <p style="position: absolute;right:-12%;color:var(--subject--text)">{{item.endpile}}</p>
                                </el-row>
                           </div>
                        </div>
                    </div>
                    <div class="tags">
                        <div class="tags_one">
                            <p style="color:var(--subject--text)">当前铺排完成百分比</p>
                            <div class="tags_two">
                                <img style="width:30px;height:30px" src="@/assets/icon/icon_1.png" alt="">
                                <div>
                                    <p>总体</p>
                                    <p>{{getFact()}}%</p>
                                </div>
                            </div>
                            <div class="tagsScroll tags_three" >
                                <div v-for="(num ,idx) in Material_group_fact" :key = idx class="tagsScroll_inner">
                                    <div class="event_title" >
                                        <el-select :disabled='true'  class="inputInner eventInner" :value="num.label">
                                            <el-option
                                            v-for="item in labelGroup"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <p style="text-align:center">{{num.value}}%</p>
                                </div>
                            </div>
                        </div>
                        <div class="tags_one">
                            <p style="color:var(--subject--text)">计划铺排完成百分比</p>
                            <div class="tags_two">
                                <img style="width:30px;height:30px" src="@/assets/icon/icon_1.png" alt="">
                                <div >
                                    <p>总体</p>
                                    <p>{{getSchedule(new Date())}}%</p>
                                </div>
                            </div>
                            <div class="tagsScroll tags_three" >
                                <div v-for="(num ,idx) in Material_group_fact" :key = idx class="tagsScroll_inner">
                                    <div class="event_title" >
                                        <el-select :disabled='true'  class="inputInner eventInner" :value="num.label">
                                            <el-option
                                            v-for="item in labelGroup"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <p style="text-align:center">{{getSchedule(new Date())}}%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transition-group  name="fade" appear >
                <div class="pop_class" v-if="isPopUp" key='1'>
                        <pop_ups v-if="isPopUp" :menuDetail = 'menuDetail'  :menuTags = 'menuTags' :menuNames = 'menuNames' :cunrrentMenu = 'cunrrentMenu' @exit='exit'></pop_ups>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import theme from '@/components/theme';
import pop_ups from '@/components/pop_ups';
import css from '@/css/home.css';
import css2 from '@/css/enter.css';
import css3 from '@/css/form.css';
import API from '@/api/material';

export default {
    name:'home',
    components:{
        theme,
        pop_ups,
    },
    data(){
        return{
            layer_detail:[],
            checkedEvents: [],
            isPopUp:null,
            fullscreenLoading:false,
            menuList:["management","qulity","material","equipment"],
            menuTags:[],
            menuNames:[],
            menuDetail:[],
            labelGroup:[],
            cunrrentMenu:'',
            layout:false,
            Tag:true,
            TagOn:false,
            Tag_unit:false,
            visualProgress:{},
            Material_group_plan:[],
            Material_group_fact:[],
            Material_nums_fact:[],
            Material_nums:[],
            MaterialUse:[],
            eventOptions:[],
            fade_top:{
                width:"100%",
                height: '100%',
                'background-color':'#314D79',
            },
            backtrackingFlag:false,
        }
    },
    computed:{

    },
    methods:{
        click(val){
            document.getElementById('iframe')
         .contentWindow.postMessage(val, 
                "http://pupai.nas.cpolar.cn")

                if(this.$store.state.themeIdx ==0){
                document.getElementById('iframe')
                .contentWindow.postMessage(3, 
                    "http://pupai.nas.cpolar.cn")
                }else{
                    document.getElementById('iframe')
                .contentWindow.postMessage(4, 
                    "http://pupai.nas.cpolar.cn")
                }
        },
        // onload(){
        //     document.getElementById('iframe')
        //  .contentWindow.postMessage(1, 
        //         "http://192.168.0.110:8082/")
        // },
        outOfDetail(){
            if(this.$refs.tag.classList[this.$refs.tag.classList.length-1]=='tag_in'){
                this.$refs.tag.classList.remove('tag_in');
                this.$refs.menu.classList.remove('menu_in');
                this.$refs.tag_unit.classList.add('tag_unit_in');
                this.$refs.tag_unit.classList.remove('tag_unit_out');
            }else{
                this.$refs.tag.classList.add('tag_in');
                this.$refs.menu.classList.add('menu_in');
                this.$refs.tag_unit.classList.remove('tag_unit_in')
                this.$refs.tag_unit.classList.add('tag_unit_out');
            }
        },
        showWorkArea(key,item){
            let a = item
            a.Material_group_fact = this.Material_group_fact[key].value;
            this.layer_detail = a;
            
            if(this.$refs.tag.classList[this.$refs.tag.classList.length-1]=='tag_in'){
                this.$refs.tag.classList.remove('tag_in');
                this.$refs.menu.classList.remove('menu_in');
                this.$refs.tag_unit.classList.add('tag_unit_in');
                this.$refs.tag_unit.classList.remove('tag_unit_out');
            }else{
                this.$refs.tag.classList.remove('tag_on');
                this.$refs.tag.classList.add('tag');
                this.$refs.tag.classList.add('tag_in');
                this.$refs.menu.classList.add('menu_in');
                this.$refs.tag_unit.classList.remove('tag_unit_in');
                this.$refs.tag_unit.classList.add('tag_unit_out');
                // this.$refs.tag.classList.add('tag_reverse');


                this.isTagOn();
            }
        },
        getYear(t){
         //t 代表指定的参数
            if (t==null)
                {
                    var Year = new Date().getFullYear(), s = 0, d;//获取当前年
                    for (var i = 1; i < 13; i++) {
                        d = new Date(Year, i, 0);//获取某一个月的天数
                        s += d.getDate();
                    };
                    return s;
            } else if(t >= 1970) {
                    var Year = new Date().getFullYear(), s = 0, d;
                    for (var i = 1; i < 13; i++) {
                        d = new Date(t, i, 0);
                        s += d.getDate();
                    };
                    return s;
            } else {
                return "年份有误";
            } 
            
        },
        getFact(){
            let divide = Math.floor(this.Material_nums_fact/this.Material_nums*100)
            return  divide
        },
        getSchedule(date){
            let sub =  Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
            let de = this.getYear(date.getFullYear());
            let divide = Math.floor(sub/de*100);
           return divide
        },
        summarizingLayer(){
            new Promise((resolve,reject)=>{
                API.getMaterial_nums(this.$store.state.API_params2)
                .then(res=>{
                    this.Material_nums = this.formatTableList(res.message.obj);
                })
                .then(()=>{
                    API.getMaterialUseList(this.$store.state.API_params).then(res=>{
                        this.MaterialUse = this.formatTableList2(res.message.obj);
                        this.Material_group_fact = this.formatFactList(this.MaterialUse);
                        this.Material_nums_fact = this.formatTableList3(res.message.obj);
                        resolve(res.message.obj);
                    }).catch(err=>{
                        resolve(0);
                        console.log(err);
                    });
                })
                .catch(err=>{
                    console.log(err);
                })
            }).then(()=>{
                this.GetVisual();
            })
                
            //通过进场管理获取所有排类型的进场总量
            //通过材料使用，获取并汇总每个工区每个排类型实际进场总量
        },
        formatTableList2(list){
            let tmpList=[];
            //Create a list of unduplicated workspaces
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                            id:list[i].id,
                            materialtype_id:[list[i].materialtype_id],
                            engineerregion_id:list[i].engineerregion_id,
                            // engineerRegionName:list[i].engineerRegionName,
                            num:[list[i].num],
                            total:0,
                        })
                for(var j = 0; j <tmpList.length-1;j++){
                    //Determine whether the work area is repeated
                    if(i!=0&&tmpList[tmpList.length-1].engineerregion_id==tmpList[j].engineerregion_id){
                    //same 
                        //Determine if the material is duplicate
                        let flag = true;
                        for(let x = 0;x < (tmpList[j].materialtype_id).length && flag;x++){
                            if(tmpList[tmpList.length-1].materialtype_id[0]==tmpList[j].materialtype_id[x]){
                            //same，summation
                                    tmpList[j].num[x] += tmpList[tmpList.length-1].num[0]; 
                                    flag = false;
                            }else{
                            //different，push a new mmaterial
                                    tmpList[j].materialtype_id.push(tmpList[tmpList.length-1].materialtype_id[0]); 
                                    tmpList[j].num.push( tmpList[tmpList.length-1].num[0]);
                                    flag = false;
                            }
                        }
                        //delete the end of the tmpList
                        tmpList.pop();
                    }else{
                        //same workspace，continue
                    }
                }
                
            }
            return tmpList
        },
        formatTableList(list){
            let sum = 0;
            for(var i = 0; i <list.length;i++){
                sum += list[i].totalNum;
            }
            return sum
        },
        formatTableList3(list){
            let sum = 0;
            for(var i = 0; i <list.length;i++){
                sum += list[i].num;
            }
            return sum
        },
        formatGroupList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].engineering_region_name,
                })
            }
            return tmpList
        },
        formatFactList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                let sum = 0;
                (list[i].num).forEach(ele => {
                    sum += ele;
                    });
                tmpList.push({
                    value:Math.floor(sum/this.Material_nums*100)==0?1:Math.floor(sum/this.Material_nums*100),
                    label:list[i].engineerregion_id,
                })
            }
            return tmpList
        },
        getLayerNumByid(id){
            let params = {
                action:'select_prograss',
                engineerregion_id:id
            }
                    API.getLayerNumByids(params).then(res=>{
                        return Object.values(res.message.obj ==null?{}:res.message.obj )
                    }).catch(err=>{console.log(err);})
        },
        formatAreaList(list){
            for(var i = 0; i <list.length;i++){
                // this.visualProgress[`item${i}`] = {
                this.visualProgress[`${i}`] = {
                    id:list[i].id,
                    label:list[i].engineerregion_id,
                    startpile:"K0+840",
                    endpile:'K1+332',
                    layerNumArr:list[i].num,
                    layerShowArr:[],
                    total:this.Material_nums
                };
                
            }
            return 1
        },
        GetVisual(){
            API.getEngineerRegion(this.$store.state.API_params).then((res)=>{
                this.labelGroup = this.formatGroupList(res.message.obj)
              if(this.formatAreaList(this.MaterialUse))  {
                    this.fullscreenLoading = !this.fullscreenLoading;
                    this.fullscreenLoading = !this.fullscreenLoading;
                }            
            }).then(()=>{
                Object.values(this.visualProgress).forEach((item,index)=>{
                            if(item != []){
                                for(var k= 0;k<item.layerNumArr.length;k++){
                                    item.layerShowArr[k] = (item.layerNumArr[k]/item.total)
                                }
                            }
                    })  
            }).then(()=>{
                    this.fullscreenLoading = !this.fullscreenLoading;
                    this.fullscreenLoading = !this.fullscreenLoading;
            }).catch(err=>{
                console.log(err);
            });
        },
        isTagOn(){
            let arr = [];
            for (let index = 0; index < this.$refs.tag.classList.length; index++) {
                arr.push(this.$refs.tag.classList[index])
                
            }
            this.Tag = arr.includes('tag')
          return this.Tag
        },
        editDeteil(){},
        checkDeteil(){
            if(this.$refs.tag.classList[this.$refs.tag.classList.length-1]=='tag'){
                this.summarizingLayer()
                this.$refs.tag.classList.remove('tag');
                this.$refs.tag.classList.add('tag_on');
            }else{
                this.$refs.tag.classList.remove('tag_on');
                // this.$refs.tag.classList.add('tag_reverse');
                this.$refs.tag.classList.add('tag');
                
                // setTimeout(()=>{
                // this.$refs.tag.classList.remove('tag_reverse');
                // this.$refs.tag.classList.add('tag');
                // this.isTagOn();
                // },750)
            }
            this.isTagOn();
        },
        ampImg(){
        
        },
        getPop(options){
            if( this.cunrrentMenu == this.menuList[options]) return;
            this.$store.state.cunrrentPath = 0;
            if(options == 0){
                this.menuTags = ["division","schedule","mission","events"];
                this.menuNames = ["工程划分","进度计划","任务发送","事件管理"];
                this.menuDetail = ["工程划分管理","进度计划管理","任务发送管理","进度事件管理"];
                this.cunrrentMenu = this.menuList[options]
                this.$router.push(`/home/${this.cunrrentMenu}/${this.menuTags[0]}`)
            };
            if(options == 1){
                this.menuTags = ["overview","relaying","event_management"];
                this.menuNames = ["质量预览","重铺计划","事件管理"];
                this.menuDetail = ["质量预览","排体重铺","质量事件管理"];
                this.cunrrentMenu = this.menuList[options];
                this.$router.push(`/home/${this.cunrrentMenu}/${this.menuTags[0]}`)
            };
            if(options == 2){
                this.menuTags = ["overview","enter","material_amount"];
                this.menuNames = ["材料概览","进场管理","材料使用"];
                this.menuDetail = ["材料概览","材料进场管理","材料图纸量使用"];
                this.cunrrentMenu = this.menuList[options];
                this.$router.push(`/home/${this.cunrrentMenu}/${this.menuTags[0]}`)
            };
            if(options == 3){
                this.menuTags = ["eq_overview","eq_management","eq_event_management"];
                this.menuNames = ["设备概况","设备编辑","事件管理"];
                this.menuDetail = ["设备概况","船舶设备编辑","船舶设备事件管理"];
                this.cunrrentMenu = this.menuList[options];
                this.$router.push(`/home/${this.cunrrentMenu}/${this.menuTags[0]}`)
            };
            if(options == 4){
                this.backtrackingFlag = !this.backtrackingFlag;
                this.click(this.backtrackingFlag?1:2);
                return 0
            };
            this.isPopUp = true;
        },
        exit(){
            this.isPopUp = false;
            this.cunrrentMenu = '';
            if(this.$route.path != '/home') this.$router.push('/home');
        },
        preventDefaults(){
            // let isEdge = /Edge/.test(navigator.userAgent);
            // let isChrome = /Chrome/.test(navigator.userAgent);
            // let isFirefox = /Firefox/.test(navigator.userAgent);
            
            // if(isEdge||isChrome||isFirefox){
                document.addEventListener('contextmenu',function(e){
                    if(e){
                        e.preventDefault();
                    }
                },{passive:false})
            //     }
            document.oncontextmenu = (e) => {
                e.preventDefault()
            }
        }
    },
    beforeMount(){
            this.preventDefaults();
            this.summarizingLayer()
    },
    watch:{

    },
    mounted(){
        if(this.$route.path != '/home') this.$router.push('/home');
        let self = this;
        this.$nextTick(()=> {
                    this.fullscreenLoading = true;
                        setTimeout(() => {
                        this.fullscreenLoading = false;
                        }, 300);
                        setTimeout(() => {
                        this.layout = true;
                        }, 300);
        // document.addEventListener('keyup', function (e) {
        // if (e.keyCode == 27) {
        //                     self.exit();
        // }
        //     })
                })
        this.$store.commit('getUniversalClass');      

    }
}
</script>

<style scoped>
.right .table_area{
    margin-top: 0%;
    height: 90%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: var(--border--radius);
    overflow: hidden;
    background-color: var(--subject--body);
    box-shadow: 0px 2px 20px 5px var(--subject--boxShadow);
}
.tag_unit .tag_body{
    width: 100%;
    
}
.tag_body .top{
    height:40%;
    display: flex;
    justify-content: space-around;
}
.top .event_title{
    width: 20%;
    margin-top:1%;
}
.top .colBox{
    width: 80%;
    margin-top:1%;
}
.bottom .colBox{
    width: 100%;
    height: 30%;
    display: flex;
}
.tag_body .bottom{
    height:60%;
    display: flex;
}
.tag_body .left{
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: space-around;
}
.tag_body .right{
    width:  60%;
    height: 100%;
    display: flex;
    align-items: center;
}



.bottom #bgcontent{
    width:100%;
    min-width:3px;
    background: #eff4fb71 !important;
    position: absolute;
    top: 0;
    z-index: 0;
}
.top #bgcontent{
    width:91.1%;
    min-width:3px;
    background: #eff4fb71 !important;
    position: absolute;
    top: 0;
    z-index: 0;
}
.tag_on #bgcontent{
    width:88%;
    min-width:3px;
    background: #eff4fb71 !important;
    position: absolute;
    top: 0;left: 12%;
    z-index: 0;
}
.tag #bgcontent{
    width:100%;
    min-width:3px;
    background: #eff4fb71  !important;
    position: absolute;
    top: 0;
    z-index: 0;
}




>>>.eventInner{
    /* font-size: 0.5vw !important; */
    font-size: 10px !important;
}
>>>.event_title > .el-select{
    width: 100%;
}
>>>.event_title > .el-select > .el-input  .el-icon-arrow-up:before{
    display: none;
}
>>>.event_title > .el-select > .el-input > .el-input__inner{
    border: none;
    /* border-radius: var(--border--radius); */
    background-color: transparent;
    transition: var(--subject--transition);
    height: 40%;
    line-height: normal;
    color: var(--subject--pop--table-text);
    text-align: center;
    padding: 0;
}
.trend-container2{
    height: 100%;
    width: 100%;
}
.tags_one{
    display:flex;height:40%;width:100%;align-items:center;justify-content:space-around;
    font-size: 20px;
    /* font-size: 1vw; */
}
.tags_two{
    display:flex;justify-content:space-around;color:var(--subject--text);height:90%;width:100px;box-shadow: 0 1px 40px 20px rgba(98, 98, 98, 0.066);border-radius:var(--border--radius);align-items:center;
}
.tags_three{
    display:flex;
    max-width:500px;
    width: 30%;
    height:90%;
    box-shadow: 0 1px 40px 20px rgba(98, 98, 98, 0.066);
    border-radius:var(--border--radius);
    align-items:center;
    overflow-x: scroll;
}
.bg-purple-light{
    background:#EFF4FB !important;
}
.bg-purple{
    background:#415BE0 !important;
}
.grid-content{
    min-height: 10px !important;
}
.workArea{
    height: 1%;
    line-height:1%;
}
.colP{
    display: flex;
    justify-content: center;
}          

.el-row {
margin-bottom: 20px;
display: flex;

}
.el-row:last-child {
    margin-bottom: 0;
}
.el-col {
border-radius: 4px;
color: var(--subject--text);
z-index: 1;
align-items: center;
}
.bg-purple-dark {
background: #99a9bf;
}
.bg-purple {
background: #d3dce6;
}
.bg-purple-light {
background: #e5e9f2;
}
.grid-content {
border-radius: 4px;
min-height: 36px;
}
.row-bg {
padding: 10px 0;
background-color: #f9fafc;
}


.tag_head, .projectInfo_head{
   display: flex;
   justify-content: center;
}
.tagInner_box{
    height: 100%;
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.tagInner_box h1{
    font-size: 20px;
    /* font-size: 1vw; */
    color: var(--subject--title);
}
.check_deteil{
    max-width: 80px;
    max-height: 35px;
    width: 90px;
    height: 40px;
    font-size: 16px !important;
    /* width: 4.5vw;
    height: 2vw;
    font-size: 0.8vw !important; */
    overflow: hidden;
}

.deteil .title{
    color: var(--subject--text);
    font-size: 12pt;
}
.deteil .inner{
    color: var(--subject--text);
    margin-top: 3%;
    font-size: 10pt;
}

.TagButtons{
    width: 15%;
    display: flex;
    justify-content: space-between;
}


</style>